import { render, staticRenderFns } from "./dyh-sougouImage.vue?vue&type=template&id=6084221b&scoped=true&"
import script from "./dyh-sougouImage.vue?vue&type=script&lang=js&"
export * from "./dyh-sougouImage.vue?vue&type=script&lang=js&"
import style0 from "./dyh-sougouImage.vue?vue&type=style&index=0&id=6084221b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6084221b",
  null
  
)

export default component.exports